import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    CardModule,
    ButtonModule,
    ToastModule
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {

  constructor(private loginService: LoginService, private router: Router) {
    this.loginService.firebaseAuth.onAuthStateChanged((user) => {
      if (user) {
        router.navigate(['/my-renders'])
      }
    })
  }

  loginWithGoogle(){
    this.loginService.loginWithGoogle()
  }
  loginWithGithub() {
    this.loginService.loginWithGithub()
  }

  loginWithTwitter() {
    this.loginService.loginWithTwitter()
  }
}
